const transformer = function (origin, defs, rowData) {
  return {
    render: 'gis',
    origin,
    defs,
    value: {
      origin: [{ coordinates: origin, type: 'Point' }],
      defs,
      rowData,
    },
  }
}

export default transformer
